<template>
  <hic-list-page title="角色管理" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码" hide-footer>
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small" v-if="permission.masterdata_role_create">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
    </template>

    <el-table-column v-if="permission.masterdata_role_edit || permission.masterdata_role_delete || permission.masterdata_role_staff" label="操作" width="150" align="center" fixed="left">
      <template slot-scope="scope">
        <el-button v-if="permission.masterdata_role_edit && scope.row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />
        <hic-regret-button v-if="permission.masterdata_role_delete && scope.row.id" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
        <el-button v-if="permission.masterdata_role_staff && scope.row.id" type="success" icon="el-icon-user" circle plain size="mini" @click="bindMember(scope.row)" class="left-pad" />
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" align="left"></el-table-column>
    <el-table-column label="排序" prop="seqNo" width="50" align="right"></el-table-column>

    <role-edit v-if="showEditor" :visible.sync="showEditor" :role-id="editingRoleId" @ok="page" />
    <staffs-edit v-if="showStaffs" :visible.sync="showStaffs" :role="entity" />
  </hic-list-page>
</template>
<script>
import api from './api.js';
import store from '@/common/store';
import { mapGetters } from 'sw-hic';
// import cfg from "@/common/cfg"
export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (!store.getters.permission.masterdata_role_query) {
      next({
        name: 'err',
        params: { err: cfg.errs.NeedPromission },
      });
    } else {
      next();
    }
  },
  components: {
    'role-edit': () => import('./edit'),
    'staffs-edit': () => import('./staffs'),
  },
  data() {
    return {
      showStaffs: false,
      meta: {
        loading: false,
      },
      searchLoading: false,
      showEditor: false,
      entities: {},
      editingRoleId: 0,
      editingIndex: -1,
      entity: null,
      condition: {
        keyword: null,
        sort: 'seqNo',
        asc: true,
        pageIndexOnView: 1,
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
  },
  methods: {
    page: function (pageIndexOnView) {
      if (isNaN(pageIndexOnView)) {
        pageIndexOnView = 1;
      }
      this.condition.pageIndexOnView = pageIndexOnView;
      let _this = this;
      this.meta.loading = true;
      api.Role.query(this.condition).then(res => {
        _this.entities = res;
        _this.meta.loading = false;
      });
    },
    create: function () {
      this.editingRoleId = 0;
      this.showEditor = true;
    },
    edit(row, index) {
      this.editingRoleId = row.id;
      this.editingIndex = index;
      this.showEditor = true;
    },
    del: function (row, index) {
      let _this = this;
      api.Role.del(row.id).then(res => {
        this.$utils.log(res);
        _this.entities.items.splice(index, 1, {});
        _this.$message.success('删除成功！');
      });
    },
    bindMember(row) {
      this.entity = row;
      this.showStaffs = true;
    },
  },
};
</script>
